// extracted by mini-css-extract-plugin
export var letter = "split-text-module--letter--69ef7";
export var space = "split-text-module--space--0f3e0";
export var word = "split-text-module--word--96a69";